import moment from 'moment';

class SubmitTimesheetController {
  constructor($scope, $uibModalInstance, AuthenticationService, $rootScope, $state) {
    "ngInject";
    this.$uibModalInstance = $uibModalInstance;
    this.authenticationService = AuthenticationService;
    this.$rootScope = $rootScope;
    this.$state = $state;
    
    // Initialize signature properties
    this.signatureUrl = null;
    this.hasSignature = false;
    this.userName = '';
    this.signatureDate = moment().format('MMM DD, YYYY');
    // Update signature info
    this.updateSignatureInfo();
  }
  
  /**
   * Update the signature URL and user info
   */
  updateSignatureInfo() {
    const user = this.authenticationService.user;
    if (!user) {
      return;
    }
    
    // Set user name
    this.userName = user.fullName || `${user.firstName} ${user.lastName}`;
    
    
    // Check if user has a signature
    // user.signature should be truthy if they have a signature (could be true, a string, or an object)
    if (user.hasSignature) {
      this.hasSignature = true;
      this.signatureUrl = this.$rootScope.apiHost + "/api/users/me/signature";
    } else {
      this.hasSignature = false;
      this.signatureUrl = null;
    }
  }
  
  /**
   * Check if submit button should be disabled
   * Only disable for submit/resubmit if no signature
   */
  isSubmitDisabled() {
    const status = this.$uibModalInstance.status;
    // Only require signature for submit/resubmit actions
    if (status === 'submit' || status === 'resubmit') {
      return !this.hasSignature;
    }
    // For other actions (like request-rejection), don't disable based on signature
    return false;
  }
  
  /**
   * Navigate to profile page to set up signature
   */
  goToProfile() {
    this.$uibModalInstance.dismiss('cancel');
    // Use 'profile' state since it has parent: 'app' in routes.js
    this.$state.go('profile');
  }

  updateStatus() {
    this.$uibModalInstance.updateStatus();
  }

  getTitle() {
    if(this.$uibModalInstance.status === 'submit' || this.$uibModalInstance.status === 'resubmit') {
      return 'Submit Timesheet';
    } else if(this.$uibModalInstance.status === 'request-rejection') {
      return  'Request to Modify My Timesheet';
    }
  }

  getMessage() {
    if(this.$uibModalInstance.status === 'submit' || this.$uibModalInstance.status === 'resubmit') {
      return "I hereby certify that the timesheet submitted for the period accurately represents the work performed by me during this timeframe. I affirm that all hours logged correspond to the tasks and responsibilities assigned to me within the scope of my employment. " +
        'I attest that the information provided in the timesheet is true and complete to the best of my knowledge and belief. Any discrepancies or inaccuracies, if discovered, will be promptly reported and rectified. \n' +
        '\n' +
        'Furthermore, I understand the importance of maintaining accurate records for payroll and project management purposes, and I am committed to upholding the integrity of this timesheet.';
    } else if(this.$uibModalInstance.status === 'request-rejection') {
      return  'I need to make some changes.';
    }
  }

  getButtonName() {
    if(this.$uibModalInstance.status === 'submit' || this.$uibModalInstance.status === 'resubmit') {
      return "Submit";
    } else if(this.$uibModalInstance.status === 'request-rejection') {
      return  "Request";
    }
  }

  cancel() {
    this.$uibModalInstance.cancel();
  }

}

export default SubmitTimesheetController;



// WEBPACK FOOTER //
// ./client/pages/timesheet/modals/submit-timesheet/submit-timesheet.controller.js